module.exports = __webpack_public_path__ + "img/czc.54566019.jpg";